;(function () {
  'use strict'

  angular
    .module('contrast.attacks')
    .controller('AttackEventsCtrl', AttackEventsCtrl)

  function AttackEventsCtrl(
    _,
    $,
    he,
    $scope,
    $rootScope,
    $routeParams,
    $routeSegment,
    $q,
    $timeout,
    $uibModal,
    $filter,
    $translate,
    traceRenderers,
    logger,
    dialogs,
    permissions,
    csTemplates,
    ErrorService,
    PromiseService,
    TimeService,
    LoadFilterService,
    AdvancedFiltersService,
    AttackEventsFactory,
    FeaturesService,
    RuleExclusionService,
    TagFactory,
    IPBlacklistModalService,
    GridToggleService,
    GLOBAL_EVENTS,
    GRID_TOGGLED_EVENT,
    ATTACK_STATUS_LABEL,
    ATTACK_STATUS,
    QUICK_FILTERS,
    SUBFILTERS,
    ATTACK_SORTS,
    ATTACK_EVENT_TYPE,
    DEFAULT_DATE_FORMAT,
    UNKNOWN_SOURCE_KEY,
    AGENT_FEATURE
  ) {
    'ngInject'

    // Minimum event amount to avoid sending footer to bottom
    var minEventsForNormalFooter = 10

    var translGlobal = {
      title_overview: $translate.instant('title_overview'),
      title_details: $translate.instant('title_details'),
      title_request: $translate.instant('title_request'),
      title_discussion: $translate.instant('title_discussion')
    }

    var momentFormat = TimeService.getDateTimeFormat(),
      lastSubfilterSearches = {},
      subfilterIds = SUBFILTERS.EVENTS.LIST,
      selectedSubFilters =
        AdvancedFiltersService.generateSelectedConfig(subfilterIds),
      requestMapping = SUBFILTERS.EVENTS.REQUEST_MAPPING,
      timeDiff = TimeService.getOffsetDifference(),
      suppressSingleEventUrl = 'views/attacks/suppress_event_single.tpl.html',
      suppressSingleUnknownEventUrl =
        'views/attacks/suppress_event_single_unknown.tpl.html',
      suppressMultipleEventUrl =
        'views/attacks/suppress_event_multiple.tpl.html',
      _searchKeywords = '',
      numPerPage = 15,
      lastSearch = {},
      validExclusionLanguages = [],
      validVirtualPatchLanguages = [],
      _deregisterDateChangeListener,
      _deregisterGridToggleListener

    angular.extend($scope, AdvancedFiltersService.getSubfilterLimitConfig())

    angular.extend($scope, {
      selectedEvents: [],
      eventCollapse: [],
      eventsOpen: 0,
      routes: [
        { label: translGlobal.title_overview, value: 'overview' },
        { label: translGlobal.title_details, value: 'details' },
        { label: translGlobal.title_request, value: 'request' },
        { label: translGlobal.title_discussion, value: 'discussion' }
      ],
      row: '-timestamp',
      events: [],
      eventTags: {},

      count: 0,
      totalCount: 0,
      lastResponseCount: 0,
      numPerLoad: 15,

      searchKeywords: searchKeywords,
      attack_labels: ATTACK_STATUS_LABEL,
      model: {
        includeSuppressed: false,
        includeBotBlockers: false,
        includeIpBlacklist: false,
        active: 'overview',
        selectAllCheckbox: false,
        format: DEFAULT_DATE_FORMAT,
        date: {
          startDate: moment().subtract(1, 'days').add(timeDiff, 'm'), // needed to parse the local time to the "user settings" time zone
          endDate: moment().startOf('minute').add(timeDiff, 'm') // needed to parse the local time to the "user settings" time zone
        },
        details: false,
        busy: true,
        eventUuid: $routeParams.eventId,
        eventTab: $routeParams.eventTab,
        isAddExclusionModalOpen: false,
        eventForExclusion: null
      },

      tagsfilters: {},
      filtersVisible: false,

      quickFilters: [],
      selectedQuickFilter: {
        name: 'All',
        filterType: 'ALL',
        count: '?'
      },
      attackUuid: $routeParams.attackUuid,
      attackValueCharacterLimit: 107,
      isLightGrid: false,
      shouldDisableCounts: false
    })

    angular.extend($scope, {
      onSelectAll: onSelectAll,
      truncateString: truncateString,
      toggleSelection: toggleSelection,
      deleteDate: deleteDate,
      loadEventsByFilterChange: subFilterSelectCallback,
      loadEventsByScroll: loadEventsByScroll,
      quickFilterSelect: quickFilterSelect,
      reloadFilters: subFilterSelectCallback,
      order: order,
      showDetails: showDetails,
      showAllStacktraces: showAllStacktraces,
      openExclusionModal: openExclusionModal,
      closeExclusionModal: closeExclusionModal,
      onExclusionAdded: onExclusionAdded,
      checkPermission: checkPermission,
      openTab: openTab,
      suppress: suppress,
      copyValue: copyValue,
      validateLanguageExclusion: validateLanguageExclusion,
      validateLanguageVirtualPatch: validateLanguageVirtualPatch,
      isProtectRuleEvent: isProtectRuleEvent,
      isVirtualPatchEvent: isVirtualPatchEvent,

      toggleFilters: toggleFilters,
      filtersSet: filtersSet,
      clearFilters: clearFilters,

      getFiltersSelected: getFiltersSelected,
      selectSubfilter: AdvancedFiltersService.selectSubfilter(
        selectedSubFilters,
        subFilterSelectCallback
      ),

      updateLastViewed: updateLastViewed,
      compareDates: compareDates,
      addNote: addNote,
      editNote: editNote,
      deleteNote: deleteNote,

      tagEvent: tagEvent,
      tagEvents: tagEvents,
      deleteTagFactory: _.memoize(deleteTagFactory),

      blacklist: blacklist,

      isNewEventOverview: isNewEventOverview,

      hasAvailableExclusionTypes: hasAvailableExclusionTypes
    })

    function isNewEventOverview(ruleName, detectionType) {
      return (
        (ruleName === 'zip-file-overwrite' ||
          ruleName === 'unsafe-file-upload' ||
          detectionType === 'SEMANTIC_ANALYSIS') &&
        ruleName !== 'cmd-injection-process-hardening'
      )
    }

    function subFilterSelectCallback() {
      loadEventsByFilterChange()
      loadSubfilters()
    }

    function blacklist(attack) {
      IPBlacklistModalService.openCreate(attack)
    }

    function tagEvent(event) {
      tagEvents([event])
    }

    function tagEvents(events) {
      var transl = {
        title_attackEvents_tagAttackEvent: $translate.instant(
          'title_attackEvents_tagAttackEvent'
        )
      }

      $uibModal
        .open({
          templateUrl: 'views/tags/modal_tag.html',
          controller: 'ModalTagAttackEventsCtrl',
          size: 'sm',
          resolve: {
            events: function () {
              return events
            },
            title: function () {
              return transl.title_attackEvents_tagAttackEvent
            }
          }
        })
        .result.then(function () {
          _.each(events, function (event) {
            _loadTags(event)
            loadEventsByFilterChange()
            loadSubfilters()
          })
        })
    }

    function deleteTagFactory(eventUuid) {
      return (data) => {
        deleteTag(data, eventUuid)
      }
    }

    function deleteTag(data, eventUuid) {
      TagFactory.deleteAttackEventTags(eventUuid, data).then(function (
        response
      ) {
        $scope.eventTags[eventUuid] = response.data.tags
      },
      ErrorService.processError)
    }

    function _loadTags(event) {
      $scope.eventTags[event.event_uuid] = []
      TagFactory.getAttackEventTags(event.event_uuid).then(function (response) {
        $scope.eventTags[event.event_uuid] = response.data.tags
      }, ErrorService.processError)
    }

    function _init() {
      if (!GridToggleService.isOldGridToggledOn()) {
        return
      }

      $scope.isLightGrid = $routeSegment.name === 'attacks.events-light'
      $scope.shouldDisableCounts = shouldDisableCounts()

      FeaturesService.getEnabledLanguagesByAgentFeature(
        AGENT_FEATURE.APP_PROTECT_EXCLUSIONS
      ).then(function (response) {
        validExclusionLanguages = [].concat.apply([], response)
      })

      FeaturesService.getEnabledLanguagesByAgentFeature(
        AGENT_FEATURE.VIRTUAL_PATCHES
      ).then(function (response) {
        validVirtualPatchLanguages = [].concat.apply([], response)
      })

      var apps = LoadFilterService.getAttackEventApps(),
        rules = LoadFilterService.getAttackEventRules(),
        attackers = LoadFilterService.getAttackEventAttackers(),
        severities = LoadFilterService.getAttackSeverities(),
        tags = LoadFilterService.getAttackEventTags(),
        noProbed = LoadFilterService.getNoProbed(),
        environment = LoadFilterService.getAttackEnvironment(),
        reloadSubfilters =
          apps ||
          rules ||
          attackers ||
          severities ||
          tags ||
          noProbed ||
          environment

      if ($scope.attackUuid) {
        $scope.$emit('attack.tab.active', { active: 'summary' })
      }

      $scope.selectedEvents = []
      $scope.events = []
      $scope.eventCollapse = []

      if (LoadFilterService.getAttackBB()) {
        LoadFilterService.setAttackBB(false)
        $scope.model.includeBotBlockers = true
      }

      if (LoadFilterService.getAttackIP()) {
        LoadFilterService.setAttackIP(false)
        $scope.model.includeIpBlacklist = true
      }

      if (
        LoadFilterService.getAttacksLive() ||
        LoadFilterService.getAttacksDate()
      ) {
        if (LoadFilterService.getAttacksLive()) {
          LoadFilterService.setAttacksLive(false)
          $scope.selectedQuickFilter.filterType = 'ACTIVE_ATTACK'
        } else if (LoadFilterService.getAttacksDate()) {
          $scope.model.date = LoadFilterService.getAttacksDate()
          LoadFilterService.setAttacksDate(false)
        }
      }

      if (reloadSubfilters) {
        _loadFilters().then(subFilterSelectCallback)
      } else {
        _loadFilters(true)
        _getQuickFilters()
        $scope.eventsPromise = _loadEvents(0, numPerPage)
      }
      _registerEvents()
    }

    function _registerEvents() {
      $scope.$on('events:updated', function () {
        _init()
      })
    }

    function removeIgnoredFilters(catalogs) {
      return catalogs.filter(function (filter) {
        return filter.id !== 'source-names'
      })
    }

    function _loadFilters(skipLoadingSubFilters) {
      return AttackEventsFactory.getFiltersCatalogs()
        .then(function (response) {
          $scope.tagsfilters.filters = removeIgnoredFilters(
            angular.copy(response.data.catalogs)
          )

          if ($scope.attackUuid) {
            $scope.tagsfilters.filters = _.without(
              $scope.tagsfilters.filters,
              _.find($scope.tagsfilters.filters, {
                id: 'attackers'
              })
            )
          }
        })
        .then(function () {
          if (!skipLoadingSubFilters) {
            loadSubfilters().then(function () {
              $scope.subFiltersLoaded = true
            })
          }
        })
        .catch(ErrorService.processError)
    }

    function loadSubfilters() {
      return AdvancedFiltersService.loadSubfilters(
        $scope.tagsfilters.filters,
        lastSubfilterSearches,
        getFiltersRequest(true),
        AdvancedFiltersService.transformSelectedSubfilters(
          selectedSubFilters,
          requestMapping
        ),
        getSubfilterRequest,
        checkSubfiltersAfterLoad,
        subfiltersSort
      ).then(clearLoadFilters)
    }

    function getSubfilterRequest(filterId, searchFilters) {
      return AttackEventsFactory.getFiltersByType(filterId, searchFilters)
    }

    function checkSubfiltersAfterLoad(filter, subFilter) {
      var shouldSelect = false
      switch (filter.id) {
        case SUBFILTERS.EVENTS.ENUM.APPLICATIONS:
          var apps = LoadFilterService.getAttackEventApps()
          if (apps && apps.indexOf(subFilter.keycode) > -1) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.EVENTS.ENUM.ATTACKERS:
          if (subFilter.keycode === UNKNOWN_SOURCE_KEY) {
            subFilter.translatedLabel = 'detail_attacks_unknown_source'
          }
          var attackers = LoadFilterService.getAttackEventAttackers()
          if (attackers && attackers.indexOf(subFilter.keycode) > -1) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.EVENTS.ENUM.ENVIRONMENTS:
          var environment = LoadFilterService.getAttackEnvironment()
          if (environment && environment.indexOf(subFilter.keycode) > -1) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.EVENTS.ENUM.RESULTS:
          if (
            LoadFilterService.getNoProbed() &&
            subFilter.keycode !== ATTACK_STATUS.PROBED.value
          ) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.EVENTS.ENUM.RULES:
          var rules = LoadFilterService.getAttackEventRules()
          if (
            rules &&
            (rules.indexOf(subFilter.keycode) > -1 ||
              rules.indexOf(subFilter.label) > -1)
          ) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.EVENTS.ENUM.SEVERITIES:
          var severities = LoadFilterService.getAttackSeverities()
          if (severities && severities.indexOf(subFilter.keycode) > -1) {
            shouldSelect = true
          }
          break

        case SUBFILTERS.EVENTS.ENUM.TAGS:
          var tags = LoadFilterService.getAttackEventTags()
          if (tags && tags.indexOf(subFilter.keycode) > -1) {
            shouldSelect = true
          }
          break

        default:
          break
      }

      if (shouldSelect) {
        subFilter.checked = true
        filter.opened = true
        AdvancedFiltersService.selectSubfilter(selectedSubFilters)(
          subFilter,
          filter
        )
      }
    }

    function subfiltersSort(subFilters, filterId) {
      switch (filterId) {
        case SUBFILTERS.EVENTS.ENUM.SEVERITIES:
          return $filter('orderBy')(subFilters, function (item) {
            return ATTACK_SORTS.SEVERITY.indexOf(item.keycode)
          })

        case SUBFILTERS.EVENTS.ENUM.RESULTS:
          return $filter('orderBy')(subFilters, function (item) {
            return ATTACK_SORTS.STATUS.indexOf(item.keycode)
          })

        case SUBFILTERS.EVENTS.ENUM.ENVIRONMENTS:
          return $filter('orderBy')(subFilters, function (item) {
            return ATTACK_SORTS.SERVER_ENVIRONMENT.indexOf(item.keycode)
          })

        default:
          break
      }
      return AdvancedFiltersService.defaultSubfilterSortFn(subFilters)
    }

    function clearLoadFilters() {
      LoadFilterService.setAttackEventApps(false)
      LoadFilterService.setAttackEventRules(false)
      LoadFilterService.setAttackEventAttackers(false)
      LoadFilterService.setAttackSeverities(false)
      LoadFilterService.setAttackEventTags(false)
      LoadFilterService.setNoProbed(false)
      LoadFilterService.setAttackEnvironment(false)
    }

    function _getQuickFilters() {
      $scope.quickFiltersPromise = AttackEventsFactory.getEventsQuickFilters(
        getFiltersRequest()
      ).then(function (response) {
        $scope.quickFilters = response.data.filters

        $scope.selectedQuickFilter = $scope.quickFilters.find(function (
          filter
        ) {
          return filter.filterType === $scope.selectedQuickFilter.filterType
        })
      }, ErrorService.processError)

      return $scope.quickFiltersPromise
    }

    function getFiltersRequest(excludeAdvanced) {
      var filters = {
        quickFilter: $scope.selectedQuickFilter.filterType,
        keyword: $scope.searchKeywords(),
        includeSuppressed: $scope.model.includeSuppressed,
        includeBotBlockers: $scope.model.includeBotBlockers,
        includeIpBlacklist: $scope.model.includeIpBlacklist,
        attackUuid: $scope.attackUuid,
        events: $scope.model.eventUuid ? [$scope.model.eventUuid] : undefined
      }

      // this matches the Attacks grid date logic
      // scripts/custom/components/attacks/attacks.controller.js-567
      if (moment($scope.model.date.startDate, momentFormat).isValid()) {
        filters.startDate = TimeService.getTimeInUserTimeZone(
          moment($scope.model.date.startDate, momentFormat).format('x')
        )
      }

      if (moment($scope.model.date.endDate, momentFormat).isValid()) {
        filters.endDate = TimeService.getTimeInUserTimeZone(
          moment($scope.model.date.endDate, momentFormat).format('x')
        )
      }

      if (!excludeAdvanced) {
        angular.extend(
          filters,
          AdvancedFiltersService.transformSelectedSubfilters(
            selectedSubFilters,
            requestMapping
          )
        )
      }

      return filters
    }

    function _loadEvents(offset, limit) {
      if (lastSearch) {
        PromiseService.cancelPromise(lastSearch)
      }

      if (offset === 0) {
        $scope.totalCount = 0
        $scope.lastResponseCount = 0
      }

      var filters = {}

      angular.extend(filters, { data: getFiltersRequest() })

      angular.extend(filters, {
        params: {
          sort: $scope.row,
          limit: limit,
          offset: offset
        }
      })

      $scope.model.busy = true

      lastSearch = $scope.isLightGrid
        ? AttackEventsFactory.getNewLightEvents(filters)
        : AttackEventsFactory.getNewEvents(filters)

      return lastSearch.then(function (response) {
        var events = response.data.events
        $scope.lastResponseCount = events.length
        $scope.totalCount = $scope.totalCount + $scope.lastResponseCount

        for (var i = 0; i < events.length; i++) {
          var event = events[i]

          if ($scope.isLightGrid) {
            event.displayName = event.display_name
            event.application = {
              app_id: event.application_id,
              name: event.application_name,
              language: event.application_language,
              roles: event.application_roles
            }
            event.server = {
              server_id: event.server_id,
              name: event.server_name,
              enabled: event.server_enabled,
              path: event.server_path,
              hostname: event.server_hostname,
              environment: event.server_environment
            }
            event.user_input = {
              value: event.user_input_value,
              name: event.user_input_name,
              type: event.user_input_type
            }
          }

          event.overview = {}
          event.details = {}
          event.request = {}
          event.discussion = {}
          permissions.updateAppPermissions(
            event.application.app_id,
            event.application.roles
          )
        }

        $scope.count = response.data.count
        $scope.events = $scope.events.concat(events)

        $timeout(function () {
          $scope.$emit('triggerScrollCheck')
        })

        if ($scope.model.eventUuid) {
          _autoOpenEvent()
        }

        if ($scope.isLightGrid) {
          if ($scope.totalCount < minEventsForNormalFooter) {
            $rootScope.$broadcast('changeFooterBottom', {
              shouldSendToBottom: true
            })
          } else {
            $rootScope.$broadcast('changeFooterBottom', {
              shouldSendToBottom: false
            })
          }
        } else {
          if ($scope.count < minEventsForNormalFooter) {
            $rootScope.$broadcast('changeFooterBottom', {
              shouldSendToBottom: true
            })
          } else {
            $rootScope.$broadcast('changeFooterBottom', {
              shouldSendToBottom: false
            })
          }
        }
        $scope.model.busy = false
      }, ErrorService.processError)
    }

    function _autoOpenEvent() {
      for (var i = 0; i < $scope.events.length; i++) {
        var event = $scope.events[i]
        if (event.event_uuid === $scope.model.eventUuid) {
          $scope.showDetails(i, event)
          break
        }
      }
    }

    function _loadEventsNote(event) {
      AttackEventsFactory.getEventNotes(event.event_uuid).then(function (
        response
      ) {
        event.notes = response.data.notes
        angular.forEach(event.notes, function (note) {
          note.unsafe = he.decode(note.note)
        })
      },
      ErrorService.processError)

      _reloadUnreadMessageStatus(event)
    }

    function _reloadUnreadMessageStatus(event) {
      AttackEventsFactory.countUnreadEventNotes(event.event_uuid).then(
        function (response) {
          event.notes_unread = response.data.unread
        },
        ErrorService.processError
      )
    }

    function _mustachify(raspStory) {
      if (raspStory.risk) {
        raspStory.risk = raspStory.risk.textFormat
          ? mustache.render(
              raspStory.risk.textFormat,
              $.extend(raspStory.risk.textFormatVariables, traceRenderers)
            )
          : ''
      }

      if (raspStory.chapters) {
        raspStory.chapters.forEach(function (chapter) {
          chapter.introText = chapter.introTextFormat
            ? mustache.render(
                chapter.introTextFormat,
                $.extend(chapter.introTextVariables, traceRenderers)
              )
            : ''

          if (/[<>]/.test(chapter.body)) {
            chapter.bodyFormat = _.escape(chapter.bodyFormat)
          }

          chapter.body = chapter.bodyFormat
            ? mustache.render(
                chapter.bodyFormat,
                $.extend(chapter.bodyFormatVariables, traceRenderers)
              )
            : ''
        })
      }
      return raspStory
    }

    function _selectAll() {
      $scope.selectedEvents = []
      angular.forEach($scope.events, function (event) {
        if (!event.suppressed) {
          event.selected = true
          $scope.selectedEvents.push(angular.copy(event))
        }
      })

      return $scope.selectedEvents
    }

    function _deselectAll() {
      $scope.selectedEvents = []
      angular.forEach($scope.events, function (event) {
        event.selected = false
      })
      return $scope.selectedEvents
    }

    function toggleFilters() {
      $scope.filtersVisible = !$scope.filtersVisible
      // Only load subfilters on initial load
      if (!$scope.subFiltersLoaded) {
        loadSubfilters().then(function () {
          $scope.subFiltersLoaded = true
        })
      }
    }

    function filtersSet() {
      var i = 0

      for (; i < subfilterIds.length; i++) {
        if (selectedSubFilters[subfilterIds[i]].length > 0) {
          return true
        }
      }
      return (
        $scope.model.includeSuppressed ||
        $scope.model.includeBotBlockers ||
        $scope.model.includeIpBlacklist
      )
    }

    function clearFilters() {
      var i = 0
      for (; i < subfilterIds.length; i++) {
        selectedSubFilters[subfilterIds[i]] = []
      }

      $scope.model.includeSuppressed = false
      $scope.model.includeBotBlockers = false
      $scope.model.includeIpBlacklist = false

      _loadFilters()
      loadEventsByFilterChange()
    }

    function getFiltersSelected(id) {
      if (id) {
        return AdvancedFiltersService.buildSelectedMessage(
          selectedSubFilters[id]
        )
      }
      return ''
    }

    function quickFilterSelect(filter) {
      $scope.selectedQuickFilter = filter
      loadEventsByFilterChange(false)
      loadSubfilters()
    }

    function deleteDate() {
      if (
        $scope.model.date.startDate !== null ||
        $scope.model.date.endDate !== null
      ) {
        $scope.model.date = { startDate: null, endDate: null }
        loadEventsByFilterChange()
      }
    }

    function onSelectAll() {
      if ($scope.model.selectAllCheckbox) {
        _selectAll()
      } else {
        _deselectAll()
      }
    }

    function toggleSelection(event) {
      var idx = $scope.selectedEvents.indexOf(event)

      if (idx > -1) {
        $scope.selectedEvents.splice(idx, 1)
      } else {
        $scope.selectedEvents.push(event)
      }

      if ($scope.selectedEvents.length !== $scope.events.length) {
        $scope.model.selectAllCheckbox = false
      }

      return $scope.selectedEvents
    }

    function order(rowName) {
      if ($scope.row === rowName) {
        return
      }
      $scope.row = rowName
      loadEventsByFilterChange()
    }

    function shouldDisableCounts() {
      return FeaturesService.isSplitFeatureFlagOn(
        'TS-24598_disable_attack_event_filter_counts'
      )
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      loadEventsByFilterChange()
      loadSubfilters()

      return _searchKeywords
    }

    function loadEventsByFilterChange(reloadQuickFilters) {
      $scope.events = []
      $scope.selectedEvents = []
      $scope.eventCollapse = []
      $scope.eventsOpen = 0

      if (angular.isUndefined(reloadQuickFilters) || reloadQuickFilters) {
        _getQuickFilters()
      }

      $scope.eventsPromise = _loadEvents(0, numPerPage)
      return $scope.eventsPromise
    }

    function loadEventsByScroll() {
      if ($scope.isLightGrid) {
        if ($scope.lastResponseCount < $scope.numPerLoad || $scope.model.busy) {
          return
        }
      } else {
        if ($scope.events.length === $scope.count || $scope.model.busy) {
          return
        }
      }

      $scope.scrollPromise = _loadEvents(
        $scope.events.length,
        $scope.numPerLoad
      )

      return $scope.scrollPromise
    }

    function onExclusionAdded(eventUuid, eventsSuppressed) {
      var attackEvent = _.find($scope.events, function (event) {
        return event.event_uuid === eventUuid
      })

      if (attackEvent) {
        attackEvent.exclusion_created = true
      }

      if (eventsSuppressed > 0) {
        $rootScope.$broadcast('events:updated', true)
      }
    }

    function closeExclusionModal() {
      $scope.model.isAddExclusionModalOpen = false
      $scope.model.eventForExclusion = null
    }

    function openExclusionModal(event) {
      $scope.model.isAddExclusionModalOpen = true

      $scope.model.eventForExclusion = {
        eventUuid: event.event_uuid,
        sourceIP: event.source,
        url: event.url,
        ruleUuid: event.rule_uuid
      }

      if (event.user_input) {
        $scope.model.eventForExclusion.userInput = {
          name: event.user_input.name,
          type: event.user_input.type
        }
      }

      if (event.application) {
        $scope.model.eventForExclusion.application = {
          id: event.application.app_id,
          name: event.application.name,
          language: event.application.language
        }
      }
    }

    function showDetails(index, event) {
      if ($scope.eventCollapse[index]) {
        $scope.eventCollapse[index] = false
        $scope.eventsOpen--
      } else {
        openTab(event, 'overview')
        if (event.story) {
          $scope.eventCollapse[index] = true
          $scope.eventsOpen++
        } else {
          $scope.eventTags[event.event_uuid] = []
          AttackEventsFactory.getEvent(
            event.event_uuid,
            'event,drilldownDetails'
          ).then(function (response) {
            var result = response.data
            event.detectionType = result.summary.event.detectionType
            event.hidden = result.summary.hidden
            event.story = _mustachify(result.summary.story)
            event.details = result.summary.details
            if (result.summary.details) {
              event.showDetailsTab =
                event.type === ATTACK_EVENT_TYPE.PROTECT_RULE &&
                (result.summary.details.stackFrames ||
                  result.summary.details.signature)

              if (result.summary.details.stackFrames) {
                event.details.stack = event.details.stack
                  ? mustache.render(event.details.stack, traceRenderers)
                  : ''
              }
              if (result.summary.details.vector) {
                event.details.vector = event.details.vector
                  ? mustache.render(event.details.vector, traceRenderers)
                  : ''
              }
              if (result.summary.details.evidence) {
                event.details.evidence = event.details.evidence
                  ? mustache.render(event.details.evidence, traceRenderers)
                  : ''
              }
            }
            if (result.summary.request) {
              event.request = _mustachify(result.summary.request)
            }
            event.hasHTTPRequest = !!result.summary.request
            if (result.summary.ruleId) {
              event.rule_id = result.summary.ruleId
            }
            event.rule_config_id = result.summary.ruleConfigId
            $scope.eventCollapse[index] = true
            $scope.eventsOpen++

            event.notes = []
            event.notes_unread = false
            _loadEventsNote(event)

            //auto-open tab
            if ($scope.model.eventTab) {
              openTab(event, $scope.model.eventTab)
            }

            _loadTags(event)
          }, ErrorService.processError)
        }
      }
    }

    function truncateString(toTruncate) {
      if (toTruncate !== null) {
        return toTruncate.length < 107
          ? toTruncate
          : toTruncate.substring(0, 50) +
              ' \n ... \n ' +
              toTruncate.substring(toTruncate.length - 50, toTruncate.length)
      } else {
        return ''
      }
    }

    function openTab(event, tab) {
      event.overview.active = false
      event.details.active = false
      event.request.active = false
      event.discussion.active = false

      if (event[tab]) {
        event[tab].active = true
        $scope.model.active = tab
      }
    }

    function showAllStacktraces(details) {
      details.lastCustomFrame = details.stackFrames.length
    }

    function copyValue() {
      var transl = {
        detail_attackEvents_eventValueCopiedToClipboard: $translate.instant(
          'detail_attackEvents_eventValueCopiedToClipboard'
        )
      }

      logger.logSuccess(transl.detail_attackEvents_eventValueCopiedToClipboard)
    }

    function validateLanguageExclusion(event) {
      return _.some(validExclusionLanguages, function (lang) {
        return event.application.language === lang
      })
    }

    function validateLanguageVirtualPatch(event) {
      return _.some(validVirtualPatchLanguages, function (lang) {
        return event.application.language === lang
      })
    }

    function hasAvailableExclusionTypes(event) {
      return (
        RuleExclusionService.getExclusionTypes(
          event.application.language,
          event
        ).length > 0
      )
    }

    function isProtectRuleEvent(event) {
      return event.type === ATTACK_EVENT_TYPE.PROTECT_RULE
    }

    function isVirtualPatchEvent(event) {
      return event.type === ATTACK_EVENT_TYPE.VIRTUAL_PATCH
    }

    function updateLastViewed(event) {
      AttackEventsFactory.updateLastViewed(event.event_uuid).then(function () {
        event.notes_unread = false
      }, ErrorService.processError)
    }

    function compareDates(note) {
      return note.creation === note.lastModification
    }

    function addNote(event) {
      AttackEventsFactory.addNote(event.event_uuid, event.note).then(function (
        response
      ) {
        logger.logSuccess(response.data.messages[0])
        event.note = ''
        _loadEventsNote(event)
      })
    }

    function editNote(event, note, data) {
      if (data.length !== 0 && note.unsafe !== data) {
        return AttackEventsFactory.editNote(
          event.event_uuid,
          note.uuid,
          data
        ).then(function (response) {
          logger.logSuccess(response.data.messages[0])
          _loadEventsNote(event)
        }, ErrorService.processError)
      }
      return $q.when(data)
    }

    function deleteNote(event, note) {
      var transl = {
        title_pleaseConfirmAction: $translate.instant(
          'title_pleaseConfirmAction'
        ),
        action_delete: $translate.instant('action_delete'),
        action_cancel: $translate.instant('action_cancel'),
        detail_deleteNote_confirmation: $translate.instant(
          'detail_deleteNote_confirmation'
        )
      }

      dialogs
        .confirm(
          transl.title_pleaseConfirmAction,
          transl.detail_deleteNote_confirmation,
          { size: 'sm', yes: transl.action_delete, no: transl.action_cancel }
        )
        .result.then(function () {
          AttackEventsFactory.deleteNote(event.event_uuid, note.uuid).then(
            function (response) {
              logger.logSuccess(response.data.messages[0])
              _loadEventsNote(event)
            },
            ErrorService.processError
          )
        })
    }

    function checkPermission(permission) {
      return permissions.hasEnterprisePermission(permission)
    }

    function suppress(events) {
      $scope.eventsDetails = events

      return csTemplates
        .loadAndInterpolate(
          events.length > 1
            ? suppressMultipleEventUrl
            : events[0].source === null
            ? suppressSingleUnknownEventUrl
            : suppressSingleEventUrl,
          {
            eventDetailsName: $scope.eventsDetails[0].displayName,
            eventDetailsSource: $scope.eventsDetails[0].source,
            eventsDetailsSize: $scope.eventsDetails.length
          }
        )
        .then(function (interpolatedStr) {
          _launchSuppressDialog(events, interpolatedStr)
        })
    }

    function _launchSuppressDialog(events, msg) {
      var transl = {
        title_attackEvents_suppressEvent: $translate.instant(
          'title_attackEvents_suppressEvent'
        ),
        action_attacks_suppress_attack: $translate.instant(
          'action_attacks_suppress_attack'
        ),
        action_cancel: $translate.instant('action_cancel')
      }
      return dialogs
        .confirm(transl.title_attackEvents_suppressEvent, msg, {
          size: 'sm',
          yes: transl.action_attacks_suppress_attack,
          no: transl.action_cancel
        })
        .result.then(function () {
          _processSuppressResults(AttackEventsFactory.suppressBatch(events))
        })
    }

    function _processSuppressResults(promise) {
      $scope.model.busy = true
      promise.then(function (results) {
        var transl = {
          detail_attacksEvents_noEventsSuppressed: $translate.instant(
            'detail_attacksEvents_noEventsSuppressed'
          )
        }

        var count = results.reduce(function (count, result) {
          return count + (result.success ? 1 : 0)
        }, 0)

        if (count === 0) {
          logger.logError(transl.detail_attacksEvents_noEventsSuppressed)
        } else {
          logger.logSuccess(
            $translate.instant(
              'plural_attacksEvents_eventsSuppressedSuccessfully',
              { count: count },
              'messageformat'
            )
          )
        }

        _init()
      })
    }

    _deregisterGridToggleListener = $scope.$on(GRID_TOGGLED_EVENT, _init)

    function _destroy() {
      _deregisterDateChangeListener()
      _deregisterGridToggleListener()
      $rootScope.$broadcast('changeFooterBottom', { shouldSendToBottom: false })
    }

    _deregisterDateChangeListener = $rootScope.$on(
      GLOBAL_EVENTS.ATTACK_EVENTS_DATE_CHANGE,
      function (e, datesObj) {
        if (datesObj) {
          searchKeywords('')
          $scope.selectedQuickFilter = $scope.quickFilters.find(function (
            filter
          ) {
            return filter.filterType === QUICK_FILTERS.ATTACK_EVENTS.ALL.KEY
          })
          $scope.model.date = datesObj
          clearFilters()
        }
      }
    )

    $scope.$on('$destroy', _destroy)

    _init()
  }
})()
